import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './cover.less'
import { getI18n } from 'client/i18n'
import { Link } from 'react-router'

import Strip from 'components/strip'
import IconCircle from 'components/common/icon_circle'

const i18n = getI18n('components/cover')

class Cover extends React.Component {
  static propTypes = {
    backgroundImage: PropTypes.string,
    gradientColor: PropTypes.string,
    backgroundPan: PropTypes.number,
    showHeader: PropTypes.bool,
    changeRedirectLocation: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string,
    ]),
    suppressPrompt: PropTypes.bool,
    dataNemo: PropTypes.string,
    customStyle: PropTypes.string,
  }

  render() {
    if (
      this.props.backgroundImage ||
      this.props.gradientColor ||
      this.props.suppressPrompt
    ) {
      return (
        <div>
          {this.props.showHeader && (
            <div styleName="cover-header">
              <span styleName="cover-info">{i18n('cover')}</span>
              <Link
                to={this.props.changeRedirectLocation}
                styleName="change-cover"
              >
                {i18n('change_cover')}
              </Link>
            </div>
          )}
          <Strip
            isResponsive={true}
            staticHeight={55}
            backgroundImage={this.props.backgroundImage}
            backgroundPan={this.props.backgroundPan}
            gradientColor={this.props.gradientColor}
            customStyle={this.props.customStyle}
          />
        </div>
      )
    }

    return (
      <Link
        to={this.props.changeRedirectLocation}
        data-pa-click="addCover"
        data-nemo={this.props.dataNemo}
        styleName="add-cover-container"
      >
        <div styleName="icon-container">
          <IconCircle type="add-photo" iconSize="big" strokeColor="blue" />
        </div>
        <div styleName="add-cover">{i18n('add_cover')}</div>
      </Link>
    )
  }
}

export default cssModules(Cover, styles)
